import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Table, Loader} from 'semantic-ui-react';
import {returnClaimTypes, returnRequestTypes} from '../../../common/dictionaries/parameters';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {shortDate} from '../../../common/constants/datesFormat';
import AcceptanceStatus from './acceptanceStatus';
import AcceptanceReason from './acceptanceReason';
import ToyotaComments from './toyotaComments';
import Attachments from './attachment';
import ClaimModal from './claim';

class ReturnContent extends Component {
  renderAcceptanceColumns(claim) {
    const {returnOrder} = this.props;

    if (!returnOrder || returnOrder.status === 'I') {
      return null;
    }

    return (
      <React.Fragment>
        <Table.Cell>
          <AcceptanceStatus
            claimCode={claim.code}
            value={claim.acceptanceStatus}
          />
        </Table.Cell>
        <Table.Cell>
          <AcceptanceReason
            claimCode={claim.code}
            value={claim.acceptanceReason}
          />
        </Table.Cell>
        <Table.Cell>
          <ToyotaComments claimCode={claim.code} value={claim.toyotaComments} />
        </Table.Cell>
      </React.Fragment>
    );
  }

  renderBody() {
    const {loading, processing, returnOrder, detail} = this.props;

    if (loading || processing) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!detail.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%' textAlign='center'>
            No se encontraron registros.
          </Table.Cell>
        </Table.Row>
      );
    }

    return detail.map((claim, index) => {
      return (
        <Table.Row key={returnOrder ? claim.code : index}>
          <Table.Cell>{moment(claim.invoiceDate).format(shortDate)}</Table.Cell>
          <Table.Cell>
            {moment(claim.receptionDate).format(shortDate)}
          </Table.Cell>
          <Table.Cell>{`${claim.invoiceSerial} - ${claim.invoiceNumber}`}</Table.Cell>
          <Table.Cell>{claim.jdeNumber}</Table.Cell>
          <Table.Cell>{claim.referralGuide}</Table.Cell>
          <Table.Cell>{claim.partCode}</Table.Cell>
          <Table.Cell textAlign='right'>{claim.invoicedQuantity}</Table.Cell>
          <Table.Cell textAlign='right'>{claim.claimedQuantity}</Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {getNumericValue(claim.unitPrice, 2)}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {getNumericValue(claim.totalPrice, 2)}
          </Table.Cell>
          <Table.Cell>{returnClaimTypes[claim.claimCode]}</Table.Cell>
          <Table.Cell>{returnRequestTypes[claim.requestCode]}</Table.Cell>
          <Table.Cell>{claim.dealerComments}</Table.Cell>
          {this.renderAcceptanceColumns(claim)}
          <Table.Cell>
            <ClaimModal icon index={index} currentClaim={claim} />
            <Attachments currentClaim={claim} />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderAcceptanceHeaders() {
    const {returnOrder} = this.props;

    if (!returnOrder || returnOrder.status === 'I') {
      return null;
    }

    return (
      <React.Fragment>
        <Table.HeaderCell>Estado</Table.HeaderCell>
        <Table.HeaderCell>Motivo</Table.HeaderCell>
        <Table.HeaderCell>Comentarios TDE</Table.HeaderCell>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Card raised fluid className='content-section'>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Fecha Factura</Table.HeaderCell>
              <Table.HeaderCell>Fecha Recepción</Table.HeaderCell>
              <Table.HeaderCell>Factura</Table.HeaderCell>
              <Table.HeaderCell>S6</Table.HeaderCell>
              <Table.HeaderCell>Guía Courier</Table.HeaderCell>
              <Table.HeaderCell>Repuesto</Table.HeaderCell>
              <Table.HeaderCell>Cant. Factura</Table.HeaderCell>
              <Table.HeaderCell>Cant. Reclamo</Table.HeaderCell>
              <Table.HeaderCell>Precio Unitario TDE</Table.HeaderCell>
              <Table.HeaderCell>Precio Total TDE</Table.HeaderCell>
              <Table.HeaderCell>Reclamo</Table.HeaderCell>
              <Table.HeaderCell>Solicitud</Table.HeaderCell>
              <Table.HeaderCell>Comentarios Concesionario</Table.HeaderCell>
              {this.renderAcceptanceHeaders()}
              <Table.HeaderCell>Acciones</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.renderBody()}</Table.Body>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'loading': state.partsReturnsOrders.loadingDetail,
    'processing': state.partsReturnsOrders.processing,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
    'detail': state.partsReturnsOrders.orderDetail,
  };
};

export default connect(mapStateToProps)(ReturnContent);
